/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const sberPayPaymentRequestDeviceOsEnum = {
    android: "android",
    ios: "ios"
} as const;

export type SberPayPaymentRequestDeviceOsEnumKey = (typeof sberPayPaymentRequestDeviceOsEnum)[keyof typeof sberPayPaymentRequestDeviceOsEnum];

export type SberPayPaymentRequest = {
    /**
     * @description Сумма платежа в копейках (минимум 240 рублей, максимум 9000 рублей)
     * @minLength 24000
     * @maxLength 900000
     * @type integer, int64
    */
    amount: number;
    /**
     * @description ОС устройства пользователя
     * @type string
    */
    device_os: SberPayPaymentRequestDeviceOsEnumKey;
    /**
     * @description URL для возврата пользователя после оплаты
     * @type string, uri
    */
    back_url: string;
};